import { useNavigate } from 'react-router-dom';

import { styled } from '@mui/system';

import { Fade, Box, Typography } from '@mui/material';

import { ButtonOutlined } from 'components/views/form/Button';
import PhoneCopyWebView from 'components/views/PhoneCopyWebView';

import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import OpsError from 'assets/images/page-erros/error-msg-iturin.png';

export const ButtonContact = styled('button')(
    ({ theme }) => `
        width: 100%;
        display: flex;
        height: 2.5rem;
        cursor: pointer;
        font-weight: 700;
        padding-top: 4px;
        border-radius: 7px;
        font-size: 1.125rem;
        align-items: center;
        margin-bottom: .75rem;
        justify-content: center;
        color: ${theme.palette.primary.light};
        border: none;

        svg {
            width: 24px;
            height: auto;
            margin-right: .65rem;
        }

        &.btn-sales {
            height: 2.5rem;
            font-size: .93rem;
            color: ${theme.palette.primary.main};
            background-color: ${theme.palette.secondary.main};

            svg {
                path {
                    fill: ${theme.palette.primary.main};
                }
            }

            &.outline {
                background-color: white;
            }
        }
`);

type Params = {
    title?: string;
    subTitle?: string;
    isWebView: boolean;
    link?: string
}

const PageErrors = ({ isWebView, link = '/central-de-trocas', title, subTitle }: Params) => {
    const navigate = useNavigate();

    return (
        <Fade in={true} {...(true ? { timeout: 500 } : {})}>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: { xs: 'calc(100vh - 21.5rem)', md: 'calc(100vh - 14rem)' }, flexDirection: 'column', textAlign: 'center', 'img': { maxWidth: '18.375rem' } }}>
                <img src={OpsError} alt="logo" />
                <Typography sx={{ fontSize: '1.125rem', fontWeight: 700, padding: '2.375rem 0 2rem' }} dangerouslySetInnerHTML={{ __html: title || 'Infelizmente não temos produtos para o seu perfil.' }}></Typography>
                <Typography sx={{ fontSize: '1rem', lineHeight: '18px', maxWidth: '37rem' }} dangerouslySetInnerHTML={{ __html: subTitle || 'Por enquanto estamos atendendo apenas <b>São Paulo e região metropolitana, </b>mas em breve atenderemos todo o Brasil.' }}></Typography>

                <Box sx={{ width: '100%', maxWidth: '24rem', marginTop: '3.1875rem' }}>
                    {isWebView ?
                        <>
                            <Typography fontSize='.75rem' paddingBottom='.2rem' fontWeight={600} textAlign='left'>
                                CENTRAL DE VENDAS
                            </Typography>
                            <Box sx={{
                                '#btn-copy': {
                                    height: '2.5rem',
                                    borderRadius: '7px',
                                    color: 'primary.main',
                                    borderColor: 'secondary.main',
                                    backgroundColor: 'secondary.main',
                                    'svg': {
                                        'path': {
                                            'fill': 'rgba(12, 28, 51, 0.5)'
                                        }
                                    }
                                }
                            }}>
                                <PhoneCopyWebView text='0800 774 2000' link='5508007742000' />
                            </Box>
                        </>
                        :
                        <ButtonContact
                            className='btn-sales'
                            onClick={() => window.open('https://wa.me/551136169000', '_blank')}>
                            {!isWebView && <WhatsAppIcon />}
                            CENTRAL DE VENDAS
                        </ButtonContact>
                    }
                    <ButtonOutlined name='VOLTAR' onClick={() => navigate(`${isWebView ? '/wb' : ''}${link}`)} />
                </Box>
            </Box>
        </Fade >
    );
}

export default PageErrors;